import { render } from "./CustomerEdit.vue?vue&type=template&id=74ab2e7b&scoped=true&ts=true"
import script from "./CustomerEdit.vue?vue&type=script&lang=ts"
export * from "./CustomerEdit.vue?vue&type=script&lang=ts"

import "./CustomerEdit.vue?vue&type=style&index=0&id=74ab2e7b&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ab2e7b"]])

export default __exports__